<div id="carDetails" class="container mx-auto" data-cy="car-details">
  <div class="form" [formGroup]="control">
    <ife-title
      [title]="'modules.evcQuote.steps.carDetails.fields.carDetails.carBrand.title' | translate"
      data-cy="car-details-title"
    ></ife-title>

    <div *ngIf="summaryVisible">
      <app-summary
        [cars]="control.get('cars')"
        (removeCar)="removeCarAtIndex($event)"
        (addNewCar)="addNewCar()"
      ></app-summary>
    </div>

    <div *ngIf="!summaryVisible" formArrayName="cars" class="m-auto">
      <div class="sm:mx-auto sm:max-w-xl mt-20">
        <ife-select
          data-cy="car-brands-select"
          [field]="selectField"
          [control]="currentCar.get('carBrand.id')"
          [disabled]="(hasPreSelection$ | async) && currentCarIndex === 0"
        ></ife-select>
      </div>

      <div *ngIf="currentCar?.get(fields.carBrandId).value !== ''" [formGroup]="currentCar" class="m-auto mt-16">
        <ife-title
          [title]="'modules.evcQuote.steps.carDetails.fields.carDetails.carModel.title' | translate"
          data-cy="car-model-title"
        ></ife-title>

        <div class="flex flex-wrap checkboxPadding justify-center">
          <div class="w-full sm:w-auto" *ngFor="let model of carModels; trackBy: trackById" data-cy="car-models">
            <ife-checkbox
              [formControlName]="fields.carModel"
              [value]="model.name"
              [caption]="model.name"
              [type]="checkboxType.text"
            ></ife-checkbox>
          </div>
          <ife-checkbox
            [formControlName]="fields.carModel"
            class="w-full sm:w-auto"
            [value]="'notInTheList'"
            [caption]="'modules.evcQuote.steps.carDetails.fields.carDetails.carModel.notInTheList' | translate"
            [type]="checkboxType.text"
            data-cy="not-in-the-list"
          ></ife-checkbox>
        </div>

        <div class="mb-8 sm:mx-auto sm:max-w-xl mt-20">
          <div *ngIf="currentCar?.get(fields.carModel).value === 'notInTheList'" class="form-element input-text mb-8">
            <label>
              {{ "modules.evcQuote.steps.carDetails.fields.carDetails.carModel.label" | translate }}
            </label>
            <input
              type="text"
              [formControlName]="fields.additionalCarModel"
              [placeholder]="'modules.evcQuote.steps.carDetails.fields.carDetails.carModel.placeholder' | translate"
              data-cy="additional-car-model"
            />
          </div>

          <div
            *ngIf="
              currentCar?.get(fields.carModel).value !== '' || currentCar?.get(fields.additionalCarModel).value !== ''
            "
            class="form-element input-text"
          >
            <label>
              {{ "modules.evcQuote.steps.carDetails.fields.carDetails.options.label" | translate }}
            </label>
            <input
              type="text"
              [formControlName]="fields.options"
              [placeholder]="'modules.evcQuote.steps.carDetails.fields.carDetails.options.placeholder' | translate"
              data-cy="options"
            />
          </div>
        </div>
      </div>
    </div>

    <ife-navigation
      [showNext]="control.valid"
      [showPrevious]="false"
      [showSetDefault]="control.invalid && !summaryVisible && currentCarIndex === 0"
      [showSkip]="control.invalid && !summaryVisible && currentCarIndex !== 0"
      (nextStep)="navigate()"
      (defaultValue)="selectNoValue()"
      (skipStep)="skip()"
    >
    </ife-navigation>
  </div>
</div>
